export enum IoTreeNodeTypeModel {
  Default,
  Category,
  Import,
  Case,
  Teeth,
  Event,
  Exam,
  Appointment,
  Library,
  Lecture,
  Trash_Patient,
  Trash_Lecture,
  Trash_Library
}
